import {
  SET_INVENTORY_INSIGHTS,
  SET_INVENTORY_INSIGHTS_ERROR,
  SET_INVENTORY_INSIGHTS_LOADING,
} from "../../actions/inventoryInsightAction";

const initialState = {
  datas: null,
  loading: false,
  error: null,
};

const inventoryInsightReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_INVENTORY_INSIGHTS:
      return {
        ...state,
        datas: action.data,
        error: null,
      };
    case SET_INVENTORY_INSIGHTS_LOADING:
      return {
        ...state,
        loading: action.status,
      };
    case SET_INVENTORY_INSIGHTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default inventoryInsightReducer;
